import './selection-button.scss';
import React, { MouseEventHandler, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Select } from 'antd';
import CustomButton from '../custom-button/custom-button';
import { SelectionOption } from './selection-option';
import CustomIcon, { IconType } from '../custom-icon/custom-icon';
import ArrowDown from '@svg/arrow-down.svg?react';
import { TooltipDisableReason } from '../tooltip-disable-message/tooltip-disable-reason';

interface SelectionButtonProps {
    options: SelectionOption[];
    onClick: MouseEventHandler<HTMLButtonElement>;
    onSelect: (value: any) => void;
    label: string;
    width: number;
    disable?: boolean;
    disableReason?: string;
    prefixIconType?: IconType;
    openChangeCb?: (open: boolean) => void;
    enableSelect?: boolean;
}

export const SelectionButton: React.FC<SelectionButtonProps> =observer(({options, onClick, onSelect, label, width, disable,
                                                                            prefixIconType, openChangeCb, enableSelect, disableReason}) => {

    const [isOpen, setIsOpen] = useState(false);

    const handleOpenChange = (open: boolean) => {
        setIsOpen(open);
        openChangeCb?.(open);
    };

    const prefixIcon = prefixIconType && <CustomIcon type={prefixIconType}/>;

    return <TooltipDisableReason disableReason={disableReason}>
        <div className={`selection-button ${disable ? 'disabled' : ''}`}>
            <CustomButton label={label} className={'selection-btn common-select'} prefixIcon={prefixIcon}
                          onClick={onClick} isDisabled={disable}/>
            <Select className={'select-in-a-btn common-select'}
                    suffixIcon={<ArrowDown />}
                    onDropdownVisibleChange={handleOpenChange}
                    open={isOpen}
                    dropdownStyle={{minWidth: `${width}px`}}
                    value={null} optionLabelProp="label" onSelect={onSelect} showSearch={false}
                    popupClassName={'dropdown-custom selection-button-dropdown'} placement={'bottomRight'} disabled={enableSelect? !enableSelect : disable}>
                {options.map(option => <Select.Option value={option.label} label={''} key={option.label}>
                    <CustomIcon type={option.icon}/>
                    {option.label}
                </Select.Option>)}
            </Select>
        </div>
    </TooltipDisableReason>;
});